import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";

import { UINumberField } from "../../../../../ui";
import { getVisibleError } from "../helpers";
import messages from "../../../../../../assets/locale/messages";
import { useSelector } from "react-redux";
import { clx } from "../../../../../../utils/Helpers";

const MarginFields = (props) => {
  const {
    formik,
    baseName,
    mode,
    checkInHasError,
    checkOutHasError,
  } = props;
  const disabled = props.disabled;
  const lang = useSelector((state) => state.locale.lang);
  const { events } = messages[lang];
  const t = events?.creatEvent?.defineRolesAndShifts;

  const isTraining = mode === "training";
  const checkInTitle = isTraining ? t.trainingCheckInMargin : t.checkInMargin;
  const checkOutTitle = isTraining
    ? t.trainingCheckOutMargin
    : t.checkOutMargin;

  return (
    <div className="margin-grid">
      <div
        className={clx("margin-panel margin-panel--checkin", {
          "margin-panel--error": checkInHasError,
        })}
      >
        <Typography
          className="margin-panel__title text-label-sm"
          component="h3"
        >
          {checkInTitle}
        </Typography>
        <div className="roles-field-grid roles-field-grid--two">
          <UINumberField
            label={isTraining ? t.beforeTrainingStarts : t.beforeWorkingStarts}
            name={`${baseName}.before_check_in_margin`}
            required
            min={0}
            disabled={disabled}
            helperText={getVisibleError(
              formik,
              `${baseName}.before_check_in_margin`,
            )}
            classNames={{
              label: "text-label-xxs text-secondary-400",
            }}
          />
          <UINumberField
            label={isTraining ? t.afterTrainingStarts : t.afterWorkingStarts}
            name={`${baseName}.after_check_in_margin`}
            required
            min={0}
            disabled={disabled}
            helperText={getVisibleError(
              formik,
              `${baseName}.after_check_in_margin`,
            )}
            classNames={{
              label: "text-label-xxs text-secondary-400",
            }}
          />
        </div>
      </div>
      <div
        className={clx("margin-panel margin-panel--checkout", {
          "margin-panel--error": checkOutHasError,
        })}
      >
        <Typography
          className="margin-panel__title text-label-sm"
          component="h3"
        >
          {checkOutTitle}
        </Typography>
        <div className="roles-field-grid roles-field-grid--two">
          <UINumberField
            label={isTraining ? t.beforeTrainingEnds : t.beforeWorkingEnds}
            name={`${baseName}.before_check_out_margin`}
            required
            min={0}
            disabled={disabled}
            helperText={getVisibleError(
              formik,
              `${baseName}.before_check_out_margin`,
            )}
            classNames={{
              label: "text-label-xxs text-secondary-400",
            }}
          />
          <UINumberField
            label={isTraining ? t.afterTrainingEnds : t.afterWorkingEnds}
            name={`${baseName}.after_check_out_margin`}
            required
            min={0}
            disabled={disabled}
            helperText={getVisibleError(
              formik,
              `${baseName}.after_check_out_margin`,
            )}
            classNames={{
              label: "text-label-xxs text-secondary-400",
            }}
          />
        </div>
      </div>
    </div>
  );
};

MarginFields.propTypes = {
  formik: PropTypes.object.isRequired,
  baseName: PropTypes.string.isRequired,
  mode: PropTypes.oneOf(["shift", "training"]),
  checkInHasError: PropTypes.bool,
  checkOutHasError: PropTypes.bool,
  disabled: PropTypes.bool,
};

MarginFields.defaultProps = {
  mode: "shift",
  checkInHasError: false,
  checkOutHasError: false,
  disabled: false,
};

export default MarginFields;
